import React from "react";
import { Chip } from "@material-ui/core";
import { AppChipsProps } from "./app-chips.types";

const AppChipsComponent: React.FC<AppChipsProps> = ({
  color = "primary",
  size = "medium",
  variant = "default",
  ...props
}) => {
  return <Chip size={size} variant={variant} color={color} {...props} />;
};

export default AppChipsComponent;
